import React from 'react';
import dayjs from 'dayjs';
import { ReactComponent as PaperPlane } from '../../resources/img/paperPlane.svg';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

const ConfirmationEmailLastSentAtBadge: React.FC<{
  lastSentAt: string;
}> = ({ lastSentAt }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      overlayStyle={{ maxWidth: 'none' }}
      overlayInnerStyle={{ whiteSpace: 'nowrap' }}
      title={t(
        'components.ConfirmationEmailLastSentAtBadge.overviewEmailSentAt',
        { dateTime: dayjs(lastSentAt).format('YYYY-MM-DD HH:mm') },
      )}>
      <div className="bg-confirmationEmailBadge-background text-confirmationEmailBadge-text rounded-full flex items-center h-8 pl-5 pr-3">
        <PaperPlane className="flex h-[16px] w-[16px] mr-2 -ml-3" />
        <div className="font-semibold">
          {t('components.ConfirmationEmailLastSentAtBadge.overviewSent')}
        </div>
      </div>
    </Tooltip>
  );
};

export default ConfirmationEmailLastSentAtBadge;
